export const gift = {
    gift_title: 'Your evolution',
    gift_points_1 : 'You have',
    gift_points_2 : 'points',
    gift_find_gift: 'Find my gift',
}